import { useTrackMutation } from '@mote/api'
import { MOTE_LINK_DOMAIN, TRACK_EVENT_NAMES } from '@mote/helpers/constants'
import { useMoteDownload } from './useMoteDownload'

export function useMoteShare(moteId: string, playbackLocation: string) {
  const trackMutation = useTrackMutation()
  const moteDownload = useMoteDownload(moteId, playbackLocation)
  const moteUrl = `${MOTE_LINK_DOMAIN}${moteId}`

  function trackSharePanelAction(action: string) {
    //@ts-expect-error
    return trackMutation.mutate({
      variables: {
        event: TRACK_EVENT_NAMES.sharePanel.action,
        action
      }
    })
  }

  function handleCopyLink() {
    return trackSharePanelAction('Copy-to-clipboard')
  }

  function handleEmbedClick() {
    return trackSharePanelAction('Embed-code-viewed')
  }

  function handleQrCodeGenerator() {
    trackSharePanelAction('QR-code-viewed')
  }

  function handleGoogleClassroomShare() {
    window.open(
      `https://classroom.google.com/u/0/share?url=${moteUrl}`,
      '_blank',
      'location=yes,height=400,width=650,scrollbars=yes,status=yes'
    )
    return trackSharePanelAction('Share-to-google-classroom')
  }

  function handleDownload() {
    return moteDownload().then(() => {
      return trackSharePanelAction('Download')
    })
  }

  function handleSaveQRImage() {
    return trackSharePanelAction('QR-image-saved')
  }

  return {
    moteUrl,
    qrCodeFilename: `mote-qr-${moteId}.png`,
    handleEmbedClick,
    handleGoogleClassroomShare,
    handleQrCodeGenerator,
    handleDownload,
    handleCopyLink,
    handleSaveQRImage
  }
}
